const KEY = 'execution-engine-profiler';
const VALUES = {
    true: 'enabled',
    false: 'disabled',
};
let enabled = sessionStorage && sessionStorage.getItem(KEY) === VALUES[true];
let data = {};

function getJobs(minDuration, getDuration) {
    return Object.values(data)
        .map(job => {
            job.t = getDuration(job);
            return job;
        })
        .filter(job => job.t >= minDuration)
        .sort((a, b) => a.t - b.t);
}

export default {
    isEnabled: () => enabled,

    enable: (value, persistent) => {
        enabled = value;
        if (persistent && sessionStorage) {
            sessionStorage.setItem(KEY, VALUES[value]);
        }
    },

    data: () => data,

    clear: () => (data = {}),

    getJobsByAwaitingTime: (minDuration = 0) =>
        getJobs(minDuration, job => job.started - job.enqueued),

    getJobsByExecutionTime: (minDuration = 0) =>
        getJobs(minDuration, job => job.finished - job.started),

    getJobsByTotalTime: (minDuration = 0) =>
        getJobs(minDuration, job => job.finished - job.enqueued),

    getStats() {
        const jobs = Object.values(data);
        const averageAwaitingTime =
            jobs.reduce((sum, job) => sum + job.started - job.enqueued, 0) / jobs.length;
        const averageExecutionTime =
            jobs.reduce((sum, job) => sum + job.finished - job.started, 0) / jobs.length;
        const averageTotalTime =
            jobs.reduce((sum, job) => sum + job.finished - job.enqueued, 0) / jobs.length;
        return {
            numberOfJobs: jobs.length,
            averageAwaitingTime,
            averageExecutionTime,
            averageTotalTime,
        };
    },
};
